import { createContext } from "react";

const EventDetailsContext = createContext({
  event: {},
  updateEvent: () => {},
  isGAOnlyEvent: false,
  setIsGAOnlyEvent: () => {},
  eventStart: null,
  storeEventStart: () => {},
  eventVisibility: null,
  storeEventVisibility: () => {},
  initialEventVisibility: null,
  updateInitialEventVisibility: () => {},
  generalOnsale: null,
  storeGeneralOnsale: () => {},
  standardAdmissionOfferHasInventory: false,
  setStandardAdmissionOfferHasInventory: () => {},
  canPublish: false,
  updateCanPublish: () => {},
  isEventPublishing: false,
  updateIsEventPublishing: () => {},
  isEventPublished: false,
  updateIsEventPublished: () => {},
  isEventOnsale: false,
  updateIsEventOnsale: () => {},
  isEventSoldout: false,
  updateIsEventSoldout: () => {},
  hasEventEnded: false,
  updateHasEventEnded: () => {},
  setSelectedAssignSeats: () => {},
});

export default EventDetailsContext;
